import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount } from "vue";

import Notification from "@/components/ui/Notification.vue";
import EmptyState from "@/components/ui/EmptyState.vue";
import OrdersService from "@/services/orders";
import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  setup(__props) {

const store = useStore();

const pending_orders = computed(() => store.pending_orders);

const visibilitychange = (event) => {
  if (!document.hidden) {
    OrdersService.pending.load();
  }
};

document.addEventListener("visibilitychange", visibilitychange);
onBeforeUnmount(() => {
  document.removeEventListener("visibilitychange", visibilitychange);
});

return { __sfc: true,store, pending_orders, visibilitychange, Notification, EmptyState }
}

})